/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesStoreGetPiFormDataRequest interface.
 */
export function instanceOfFxIdWebFeaturesStoreGetPiFormDataRequest(value) {
    if (!('OrderPublicId' in value) || value['OrderPublicId'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesStoreGetPiFormDataRequestFromJSON(json) {
    return FxIdWebFeaturesStoreGetPiFormDataRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreGetPiFormDataRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'OrderPublicId': json['OrderPublicId'],
    };
}
export function FxIdWebFeaturesStoreGetPiFormDataRequestToJSON(json) {
    return FxIdWebFeaturesStoreGetPiFormDataRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreGetPiFormDataRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'OrderPublicId': value['OrderPublicId'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesStoreGetPiFormDataRequest.js.map